// extracted by mini-css-extract-plugin
export default {"l-mcq-canvas":"McqCanvas_l-mcq-canvas__OR2X6","side-panel-mini":"McqCanvas_side-panel-mini__m+kIG","media-recovery-overlay":"McqCanvas_media-recovery-overlay__HDwGX"};